import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ErrorHandlingService,
  PaginatorNew,
  TableOrder,
  capitalizeFirstLetter,utils,InvoiceType,InvoiceDetailed
} from '../../global';
import {Observable} from 'rxjs';
import {UploadItemsResponse} from '../entities/upload.entity';
import {catchError} from 'rxjs/operators';
import {DocumentInvoiceListResponse} from '../entities/document-list.entity';
import {InvoiceFillingUpdate} from '../entities/invoice-filling.entity';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentService {
  private readonly http = inject(HttpClient);
  private readonly errorHandler = inject(ErrorHandlingService);

  public getDocuments(page: PaginatorNew, order: TableOrder, searchText: string, filters: any): Observable<UploadItemsResponse> {
    return this.http
      .get('/document-upload/list', {
        params: {
          pageNumber: `${page?.page || 1}`,
          itemsPerPage: `${page?.size || 10}`,
          ...(!!order
            ? {
                [`order${capitalizeFirstLetter(order.attribute)}`]: order.order
              }
            : {}),
          ...(!!searchText ? { searchText: encodeURIComponent(searchText) } : {}),
          ...(filters ? filters : {})
        }
      })
      .pipe(catchError((err) => this.errorHandler.handleError(err)));
  }

  public createDocument(data: InvoiceFillingUpdate): Observable<any> {
    return this.http.post('/invoices/filling', data).pipe(catchError((err) => this.errorHandler.handleError(err)));
  }

  public getInvoices(page: PaginatorNew, order: TableOrder, search: string = ''): Observable<DocumentInvoiceListResponse> {
    return this.http
      .get('/invoices/unlinked', {
        params: {
          ...(search ? { search: encodeURIComponent(search) } : {}),
          ...utils.paginatorToQueryParams(page),
          ...utils.tableOrderToQueryParams(order)
        }
      })
      .pipe(catchError((err) => this.errorHandler.handleError(err)));
  }

  public startOcr(id: number): Observable<{ status: number; invoiceId: number; isAutoFiled: boolean; type: InvoiceType; hasDetails: boolean }> {
    return this.http.get(`/documents/${id}/analyze`).pipe(catchError((err) => this.errorHandler.handleError(err)));
  }

  public verifyOcr(ids: Array<number>): Observable<Array<{ id: number; analyzed: number; hasDetails: boolean; status: number; invoiceId: number; }>> {
    return this.http.get(`/images/ocr/${(ids || []).join(',')}`).pipe(catchError((err) => this.errorHandler.handleError(err)));
  }

  public renameDocument(id: number, name: string): Observable<any> {
    return this.http.put('/upload-and-filling/rename', { id, name }).pipe(catchError((err) => this.errorHandler.handleError(err)));
  }

  public attachInvoices(invoiceId: number, documentIds: Array<string | number>): Observable<any> {
    return this.http.post('/documents/attach', { invoiceId, documentIds }).pipe(catchError((err) => this.errorHandler.handleError(err)));
  }

  public getDocumentPages(documentId: number): Observable<any> {
    return this.http.get(`/document-upload/${documentId}/pages`).pipe(catchError((err) => this.errorHandler.handleError(err)));
  }

  public loadDetailedOcr(ids: Array<number>): Observable<InvoiceDetailed> {
    return this.http.get(
      `/images/ocr-details/${(ids || []).join(',')}`
    ).pipe(
      catchError((err) => this.errorHandler.handleError(err))
    );
  }
}
